import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {withTranslation} from 'react-i18next';
import { withRouter } from 'react-router-dom';
import {DialogModal} from './common/DialogModal';
import {CreateRace} from '../race/create/CreateRace'
import { trackGoogleEvent } from '../../utils/googleEvents';
import {
  createRace,
  fetchRacesTypeAhead,
  fetchSimilarRaces
} from '../../data/CreateRaceApi';

import {
  fetchCountries,
  fetchStates
} from '../../data/CountryStateStreams';
import {connectStream} from '../../lib/bastetjs/utils/connectStream';
import {getModalState, modal} from '../../data/ModalsStream';
import {LogInOrSignUp} from './LogInOrSignUp';
import {isLoggedIn} from '../../utils/isLoggedIn';

class AddRaceModalComponent extends Component {

  static propTypes = {
    isMobile: PropTypes.bool.isRequired,
    masterId: PropTypes.number,
    hasFutureDate: PropTypes.bool.isRequired,
    event: PropTypes.object,
    buttonType: PropTypes.oneOf(['link', 'button']),
    open: PropTypes.bool,
    type: PropTypes.string,
    style: PropTypes.object,
    t: PropTypes.func
  };

  static defaultProps = {
    masterId: null,
    open: false
  };

  state = {
    masterEvent: null
  };

  static modalName = 'add-race';

  proceed = () => {
    const {buttonType, masterId} = this.props;
    switch(buttonType) {
      case 'link':
        this.redirectToNewCreatePage(masterId);
        break;
      case 'button':
        trackGoogleEvent('Race', 'Click', 'Add Event Date');
        modal.open(AddRaceModalComponent.modalName);
        break;
      default:
        break;
    }
  };

  handleTouchTap = () => isLoggedIn() ?
    this.proceed() : this.props.modal.handleTouchTap();

  handleRequestClose = () => modal.close(AddRaceModalComponent.modalName);

  redirectToNewCreatePage = (masterId) => {
    const path = '/race/create';
    trackGoogleEvent('Race', 'Click', 'Add Event');
    this.props.history.push({pathname: masterId ? `${path}/${masterId}` : path});
  };

  renderButton() {
    const {
      label,
      t
    } = this.props;

    return (
      <button
        style={label !== t('Add Event Date') ? {
            backgroundColor: '#16A9E1',
            border: '2px solid #16A9E1',
            borderRadius: 2,
            textTransform: 'uppercase',
            color: '#fff',
            paddingLeft: 33,
            paddingRight: 33,
            marginLeft: 27,
            fontSize: 14,
            marginTop: 2,
            cursor: 'pointer'
          }
          :
          {
            color: '#16A9E1',
            fontSize: 12,
            border: 'none',
            backgroundColor: 'white',
            float: 'right',
            cursor: 'pointer'
          }
        }
        onClick={this.handleTouchTap}>
        {label}
      </button>
    );
  }

  renderLink() {
    const {
      type,
      label,
      style
    } = this.props;

    return (
      <span
        id='modal-link'
        onClick={this.handleTouchTap}
        style={type !== 'eventsSearch' ? {
          cursor: 'pointer',
          marginTop: '8px',
          color: '#16a9e1',
          fontSize: '14px'
        } : style}>
        {type !== 'eventsSearch' ? '+' : ''} {label}
      </span>
    );
  }

  render() {
    const {
      isMobile,
      masterId,
      hasFutureDate,
      buttonType,
      showStartListModal = false,
      open,
      event,
      t
    } = this.props;

    const modalH1 = {
      fontSize: 25,
      float: 'left',
      width: '100%',
      color: '#4a4a4a',
      fontFamily: 'ProximaNovaRegular'
    };

    if (!open) return buttonType === 'button' ?
      this.renderButton() : this.renderLink();
    else return (
      <DialogModal
        title={
          <div style={{fontSize: 16, marginBottom: '24px'}}>
            <h1 style={modalH1} id='add-race-details'>
              {t('Add Race Details')}
            </h1>
            <span style={{
              fontSize : 15,
              fontFamily: 'ProximaNovaRegular',
              color: '#4A4A4A'
            }}>
              {t(
                'There aren\'t any start lists for the next {{eventName}}. Once you add the race details you will able to add yourself to the start list.',
                {eventName: event.name}
              )}
            </span>
          </div>}
        separator={false}
        body={
          <CreateRace
            masterId={masterId + ''}
            existingEvent={event}
            redirectToNewCreatePage={this.redirectToNewCreatePage}
            createRace={createRace}
            fetchSimilarRaces={fetchSimilarRaces}
            fetchRacesTypeAhead={fetchRacesTypeAhead}
            fetchCountries={fetchCountries}
            fetchStates={fetchStates}
            openStartListModal={showStartListModal}
            isMobile={isMobile}
            hasFutureDate={hasFutureDate}
            handleRequestClose={this.handleRequestClose}
            eventRaces={event.eventRaces}
          />
        }
        open={open}
        onRequestClose={this.handleRequestClose}
        isMobile={isMobile}
      />
    );
  }
}

export const AddRaceButton = ({isMobile, masterId, hasFutureDate, event, buttonType, label , type, style}) =>
  <LogInOrSignUp
    control='addRace'
    isLoggedIn={isLoggedIn()}
    masterId={masterId}
    hasFutureDate={hasFutureDate}
    event={event}
    isMobile={isMobile}
    label={label}
    buttonType={buttonType}
    type={type}
    style={style}
  />;

export const AddRaceModal = withTranslation()(connectStream({
  open: () => getModalState(AddRaceModalComponent.modalName)
})(withRouter(AddRaceModalComponent)));



/** WEBPACK FOOTER **
 ** ./components/modal/AddRaceModal.js
 **/